/**
 * PDFPreviewPane — F-007 Phase 4 (IMPL-P4-005).
 *
 * Renderizza il PDF originale in un `<iframe>` puntato sulla presigned URL
 * ottenuta via `usePdfUrl`. La URL ha TTL 60s lato server: il refresh è
 * gestito automaticamente dall'hook (`staleTime: 50_000`).
 */
import { usePdfUrl } from '../hooks/usePdfUrl';

interface PDFPreviewPaneProps {
  praticaId: string;
  className?: string;
}

export function PDFPreviewPane({ praticaId, className }: PDFPreviewPaneProps) {
  const { data, isLoading, error } = usePdfUrl(praticaId);

  const wrapperClass =
    'w-full h-full min-h-[600px] rounded-md border bg-muted/20' +
    (className ? ` ${className}` : '');

  if (isLoading) {
    return (
      <div
        role="status"
        aria-live="polite"
        className={`${wrapperClass} flex items-center justify-center`}
      >
        <p className="text-sm text-muted-foreground">Caricamento PDF…</p>
      </div>
    );
  }

  if (error || !data?.url) {
    return (
      <div
        role="alert"
        className={`${wrapperClass} flex items-center justify-center`}
      >
        <p className="text-sm text-muted-foreground">PDF non disponibile</p>
      </div>
    );
  }

  return (
    <iframe
      src={data.url}
      title="Anteprima PDF pratica"
      className={`${wrapperClass} border-0`}
    />
  );
}
